import React, { useContext, useEffect, useState } from 'react'
import { EMPLOYEE_PAGE_CONTENT } from '../../constants/employeeData'
import { EmployeeDataHoc } from '../../utils/hocs'
import { Spinner } from '../common/atoms'
import { Table } from '../common/molecules'
import { employeeDataApi } from '../../services'
import { handleAppError } from '../handlers'
import { UploadCard } from '../common/organisms'
import { DRAGGER_CONTENT } from '../../constants/employeeData'
import { AppStateContext, AppDispatchContext } from '../../utils/contexts'
import { PRE_EMP_RECENT_UPLOADS_HEADERS as HEADERS } from '../../constants/tableHeaders'
import { recentSearchSchema as tableschema } from '../../schemas/table'
import { SALES_ROLE } from '../../constants/overview'

const BulkUploadCard = ({ history }) => {
    const {employee_data : state} = useContext(AppStateContext)
    const dispatch = useContext(AppDispatchContext)
    const [recentUploads, setRecentUploads] = useState([])
    const [viewMoreFlag, setViewMoreFlag] = useState(false)
    const { preEmp_bulk_uploader : CONTENT } = EMPLOYEE_PAGE_CONTENT
    const backpath = CONTENT['breadcrumb']['link']

    const fetchRecentUploads = async () => {
        try {
          let result = await employeeDataApi.pre_emp_recent_upload({type: 'PreEmployeeAppointment'})
          let data = result.data.customer_data_uploads
          dispatch({ type: 'employee_data' })
          setRecentUploads(data || [])
        } catch (err) {
          handleAppError(err)
        }
      }
    
    const downloadRecetUploadReport = async (e) => {
      if (SALES_ROLE === "sales") return   
      try{
        let result = await employeeDataApi.download_recent_pre_emp_upload({id: e.id, type: e.type})
        let data = result.data.file
        const url = data.url
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleAppError(err)
      }
    } 

    const uploadRequest = (info) => {
        dispatch({ type: 'employee_data', file: info.file })
        history.push('/employee-data/file-upload?of=preEmp_bulk_uploader')
      }
    
    const viewRecentHandler = (id) => {
        history.push('/employee-data/view-result?of=preEmp_bulk_uploader', {id})
    }

    useEffect(() => {
      if (state.pathId !== '0123') dispatch({ type: 'employee_data', file: null, tabledata: null, pathId: '0123' })
      if (state.click_dragger) {
        setTimeout(() => {
          const dragger = document.getElementById('dragger')
          dragger.click()
          dispatch({ type: 'toggle dragger click' })
        }, 0)
      }
      if(state.tabledata) dispatch({ type: '', showAddIcon: true })
      fetchRecentUploads()
      }, [])

   return(
    <React.Fragment>
        <EmployeeDataHoc title={CONTENT['title']} breadcrumb={[{ text: 'Pre employment', link: '/pre-employee-checkup' }, CONTENT['breadcrumb']]} close={() => history.push(backpath)}>
            <UploadCard CONTENT={DRAGGER_CONTENT['pre_emp_bulk_upload']} uploadRequest={uploadRequest} classes='mt-8'  listHeading={["Download sample file"]} />
            <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3 mt-12'>RECENT ACTIVITY</p>
            <Table 
              classes='rounded-lg' 
              tableClasses='alternate_gray200_color' 
              loading={false} 
              loaderHeight={300} 
              headers={HEADERS} 
              data={viewMoreFlag ? recentUploads:recentUploads.slice(0, 3)} 
              tableschema={tableschema} 
              handler={viewRecentHandler}
              statusChange={downloadRecetUploadReport}
              download={true}
            />
            {recentUploads.length > 3  && <span className='text-base font-semibold text-blue-500 mt-4 block cursor-pointer' onClick={() => setViewMoreFlag(flag => !flag)}>VIEW {viewMoreFlag ? 'LESS':'MORE'}</span>}
        </EmployeeDataHoc>

    </React.Fragment>

    )
}

export default React.memo(BulkUploadCard);